<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px'
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="机台名称" prop="deviceName">
              <a-input v-model="formInline.deviceName" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="机台编号" prop="deviceNo">
              <a-input v-model="formInline.deviceNo" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <deviceContent :formInline="formInline" ref="iason"></deviceContent>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import deviceContent from "./deviceContent.vue";
export default {
  components: {
    deviceContent
  },
  data() {
    return {
      formInline: {
        deviceNo: "",
        deviceName: "",
        pageSize: 10,
        pageNo: 1
      }
    };
  },
  created() {},
  methods: {
    handleSubmit(e){
      console.log('handleSubmit:', e);
    },
    seach(e) {
      console.log(this.formInline);
      this.$refs.iason.query();
    },
    resetForm() {
      this.formInline.deviceName = "";
      this.formInline.deviceNo = "";
      this.$refs.iason.getData();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/storeManagement/deviceManagement/deviceHome.vue